import { MenuItem } from '@material-ui/core';
import Menu from './tm3-menu';

export default Menu;

export { Menu, MenuItem };
